import { Phone, ArrowRight } from "lucide-react";

const HERO_IMG = "/images/hero-living-room.jpg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero"
      className="relative w-full min-h-[92vh] flex items-end overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Warm living room at Carlene's Comfort Care"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/20 to-black/70" />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(1200px 600px at 20% 80%, rgba(44,76,59,0.35), transparent 60%)",
        }}
      />

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 md:pt-24 pb-20 md:pb-28">
        <div className="max-w-3xl">
          <p
            data-testid="hero-eyebrow"
            className="reveal text-shadow-soft text-[#F4F1EA] text-[10px] sm:text-sm uppercase tracking-[0.3em] sm:tracking-[0.35em] font-semibold mb-5 sm:mb-6"
          >
            Adult Foster Care &middot; Scio, Oregon
          </p>
          <h1
            data-testid="hero-title"
            className="reveal font-heading text-white text-shadow-soft text-[2.6rem] sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] font-medium"
            style={{ transitionDelay: "80ms" }}
          >
            A gentle home,
            <br />
            where dignity&nbsp;stays.
          </h1>
          <p
            data-testid="hero-sub"
            className="reveal mt-7 text-[#F4F1EA] text-shadow-soft text-lg sm:text-xl leading-relaxed max-w-2xl"
            style={{ transitionDelay: "180ms" }}
          >
            A Class 3 Adult Foster Home caring for up to five residents —
            specializing in Alzheimer&rsquo;s, dementia, and hospice care in a
            quiet, family-run setting.
          </p>

          <div
            className="reveal mt-10 flex flex-col sm:flex-row gap-3"
            style={{ transitionDelay: "260ms" }}
          >
            <a
              href="#contact"
              data-testid="hero-tour-btn"
              className="group inline-flex items-center justify-center gap-2 bg-[#F4F1EA] text-[#1C2A24] hover:bg-white transition-colors rounded-full px-8 py-4 font-medium"
            >
              Schedule a Tour
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="tel:+15033942321"
              data-testid="hero-call-btn"
              className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-[#F4F1EA]/80 text-[#F4F1EA] hover:bg-[#F4F1EA] hover:text-[#1C2A24] transition-colors rounded-full px-8 py-4 font-medium"
            >
              <Phone className="w-4 h-4" />
              Call (503) 394-2321
            </a>
          </div>

          <div
            className="reveal mt-14 flex flex-wrap gap-x-10 gap-y-4 text-[#F4F1EA] text-shadow-soft"
            style={{ transitionDelay: "340ms" }}
            data-testid="hero-stats"
          >
            <Stat value="5" label="Resident home" />
            <Stat value="24/7" label="On-site care" />
            <Stat value="Class 3" label="Licensed AFH" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div className="flex flex-col">
      <span className="font-heading text-3xl sm:text-4xl leading-none">
        {value}
      </span>
      <span className="text-xs uppercase tracking-[0.25em] mt-2 opacity-90">
        {label}
      </span>
    </div>
  );
}
